import { authStore } from "../stores";
import { getApiUrl } from "../utils/apiUrl";

class PromoApiService {

  check = async (gameId: number, partnerId: number): Promise<boolean> => {
    try {
      const response = await fetch(`${getApiUrl(process.env.REACT_APP_PROMO_URL!)}/api/v1/PromoCodes?gameId=${gameId}&partnerId=${partnerId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      return data.data;
    } catch (err) {
      return false;
    }
  }

  claim = async (gameId: number, code: string): Promise<boolean> => {
    const response = await fetch(`${getApiUrl(process.env.REACT_APP_PROMO_URL!)}/api/v1/PromoCodes`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authStore.accessToken}`
      },
      body: JSON.stringify({
        gameId,
        code
      })
    });
    const data = await response.json();
    console.log(data)
    if (data.error) {
      throw new Error(data.error);
    }

    return data.data;
  }

}

export const promoApiService = new PromoApiService();